const DESIGN = 0
const PERSONALITY = 1
const MIXED = 2

export default { DESIGN, PERSONALITY, MIXED }
